export const getOccupancyData = async (
    fromDate?: string,
    toDate?: string,
    country?: string,
    state?: string,
    district?: string,
    taluk?: string,
    hobli?: string,
    serviceType?: number,
    bedType?: string
) => {
    switch (bedType) {
        case "ICU":
            return {
                names: ["Vacant Beds", "Occupied Beds", "Booked Beds"],
                counts: [15, 10, 10],
                percentages: [60, 40, 40],
                colors: ['#1FAC86', '#F3A11E', '#764FA0'],
                subTitles: [
                    {
                        title: "Occupied Bed Days",
                        count: 3650,
                        percentage: 45,
                    },
                    {
                        title: "No. of Patients",
                        count: 1000,
                    },
                ],
                total: 35,

            };
        case "Ward":
            return {
                names: ["Vacant Beds", "Occupied Beds", "Booked Beds"],
                counts: [15, 10, 10],
                percentages: [60, 40, 40],
                colors: ['#F5B44B', '#1FAC86', '#DC6375'],
                subTitles: [
                    {
                        title: "Occupied Bed Days",
                        count: 3650,
                        percentage: 45,
                    },
                    {
                        title: "No. of Patients",
                        count: 1000,
                    },
                ],
                total: 35,

            };
        case "OT":
            return {
                names: ["Booked Hours", "Available Hours"],
                counts: [10, 14],
                colors: ['#F3A11E', '#764FA0'],
                subTitles: [
                    {
                        title: "Total Surgeries",
                        count: 20,
                        percentage: null
                    },
                    {
                        title: "Surgery Hours",
                        count: 4,
                    },
                ],
                total: 24,

            };
        default:
            break;
    }

};
